
/* eslint-disable @typescript-eslint/no-shadow */
export namespace GridMultiSelectGraphTypeV1 {
  export enum GridMultiSelectGraphTypeV1 {
    STACKED_COLUMN = "STACKED_COLUMN",
    GROUPED_BAR = "GROUPED_BAR",
    NONE = "NONE",
  }

  export interface GridMultiSelectGraphTypeV1DTO {
    case: string;
  }

  export const fromDTO = (dto: GridMultiSelectGraphTypeV1DTO): GridMultiSelectGraphTypeV1 => {
    if (dto === undefined || dto === null) {
      throw new InvalidGridMultiSelectGraphTypeV1Error(
        `Invalid DTO ${dto} provided for GridMultiSelectGraphTypeV1.GridMultiSelectGraphTypeV1`
      );
    }
    switch (dto.case) {
      case "STACKED_COLUMN":
        return GridMultiSelectGraphTypeV1.STACKED_COLUMN;
      case "GROUPED_BAR":
        return GridMultiSelectGraphTypeV1.GROUPED_BAR;
      case "NONE":
        return GridMultiSelectGraphTypeV1.NONE;
      default:
        throw new InvalidGridMultiSelectGraphTypeV1Error(
          `Case ${dto.case} is not valid case of GridMultiSelectGraphTypeV1.GridMultiSelectGraphTypeV1`
        );
    }
  };

  export const toDTO = (gridMultiSelectGraphTypeV1: GridMultiSelectGraphTypeV1): GridMultiSelectGraphTypeV1DTO => {
    const enumDTO = {
      case: GridMultiSelectGraphTypeV1[gridMultiSelectGraphTypeV1],
    };
    return enumDTO;
  };
}

export class InvalidGridMultiSelectGraphTypeV1Error extends Error {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidGridMultiSelectGraphTypeV1Error";
  }
}
export class InvalidGridMultiSelectGraphTypeV1StackedColumnError extends InvalidGridMultiSelectGraphTypeV1Error {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidGridMultiSelectGraphTypeV1StackedColumnError";
  }
}

export class InvalidGridMultiSelectGraphTypeV1GroupedBarError extends InvalidGridMultiSelectGraphTypeV1Error {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidGridMultiSelectGraphTypeV1GroupedBarError";
  }
}

export class InvalidGridMultiSelectGraphTypeV1NoneError extends InvalidGridMultiSelectGraphTypeV1Error {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidGridMultiSelectGraphTypeV1NoneError";
  }
}
